import React from 'react';
import Select from '../../Select';

const IndustryDetailsStep = ({ formData, onChange, errors, verticals, subVerticals }) => {
  const verticalOptions = [
    { value: '', label: '-- Select Vertical * --' },
    ...verticals.map(v => ({ value: v.verticalId, label: v.verticalName }))
  ];

  const subVerticalOptions = [
    { value: '', label: '-- Select Sub-Vertical * --' },
    ...subVerticals.map(sv => ({ value: sv.subVerticalId, label: sv.subVerticalName }))
  ];

  return (
    <div className="space-y-4">
      <Select
        label="Vertical"
        name="verticalId"
        value={formData.verticalId}
        onChange={onChange}
        options={verticalOptions}
        error={errors.verticalId}
        required
      />

      <Select
        label="Sub-Vertical"
        name="subVerticalId"
        value={formData.subVerticalId}
        onChange={onChange}
        options={subVerticalOptions}
        error={errors.subVerticalId}
        disabled={!formData.verticalId}
        required
      />
    </div>
  );
};

export default IndustryDetailsStep;
